import { FeatureName } from '../config';
import type { Feature } from '../types';

import yotpo from './yotpo';
import mulberry from './mulberry';
import stripe from './stripe';
import paypal from './paypal';
import grabpay from './grabpay';
import afterpay from './afterpay';
import affirm from './affirm';
import zippay from './zippay';
import installment2c2p from './instalment-2c2p';
import fbSign from './facebook-sign-in';
import googleSign from './google-sign-in';
import appleSign from './apple-sign-in';
import gtm from './gtm';
import cookieYes from './cookie-yes';
import uttImpact from './utt-impact';
import leadTimeFilter from './lead-time-filter';
import leadtimeDisplay from './leadtime-display';
import quickship from './quickship';
import sustainabilityFeature from './sustainability-feature';
import casaFeature from './casa';

export const FEATURES_CONFIG: Record<keyof typeof FeatureName, Feature> = {
  [FeatureName.YOTPO]: yotpo,
  [FeatureName.MULBERRY]: mulberry,
  [FeatureName.STRIPE]: stripe,
  [FeatureName.PAYPAL]: paypal,
  [FeatureName.GRABPAY]: grabpay,
  [FeatureName.AFTERPAY]: afterpay,
  [FeatureName.AFFIRM]: affirm,
  [FeatureName.ZIPPAY]: zippay,
  [FeatureName.INSTALMENT_TCTP]: installment2c2p,
  [FeatureName.FACEBOOK_SIGN_IN]: fbSign,
  [FeatureName.GOOGLE_SIGN_IN]: googleSign,
  [FeatureName.APPLE_SIGN_IN]: appleSign,
  [FeatureName.GTM]: gtm,
  [FeatureName.COOKIE_YES]: cookieYes,
  [FeatureName.UTT_IMPACT]: uttImpact,
  [FeatureName.LEAD_TIME_FILTER]: leadTimeFilter,
  [FeatureName.LEADTIME_DISPLAY]: leadtimeDisplay,
  [FeatureName.QUICKSHIP]: quickship,
  [FeatureName.SUSTAINABILITY_FEATURE]: sustainabilityFeature,
  [FeatureName.CASA]: casaFeature,
};
